import { httpPost } from "../http"

export interface v1SearchLocationScreenRecommendedAddressesResponse {
  recommend_addresses: RecommendedAddress[]
  addresses: any[]
}

export interface RecommendedAddress {
  id: number
  addr: string
  type: string
  lat: number
  lng: number
  children: []
}

export function v1SearchLocationScreenRecommendedAddresses() {
  return httpPost<v1SearchLocationScreenRecommendedAddressesResponse>(
    "be-trip/customer/get_search_location_screen_recommend_address",
    {}
  )
}

export interface v1InaccurateSavedAddressResponse {
  flag: number
}

export function v1InaccurateSavedAddress() {
  return httpPost<v1InaccurateSavedAddressResponse>(
    "be-trip/customer/inaccurate_saved_address",
    {}
  )
}
